import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { WhatWeLose } from "@/components/WhatWeLose";
import { WhatWeOffer } from "@/components/WhatWeOffer";
import { HowItWorks } from "@/components/HowItWorks";
import { DemoSection } from "@/components/DemoSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { PricingSection } from "@/components/PricingSection";
import { FaqSection } from "@/components/FaqSection";
import { CtaSection } from "@/components/CtaSection";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  return (
    <div className="relative overflow-hidden">
      <Navbar />
      <HeroSection />
      <WhatWeLose />
      <WhatWeOffer />
      <HowItWorks />
      <DemoSection />
      <TestimonialsSection />
      <PricingSection />
      <FaqSection />
      <CtaSection />
      <Footer />
    </div>
  );
}
